import React, { useState } from 'react';

interface CredentialsProps {
    username: string;
    password: string;
}

const CredentialsReveal: React.FC<CredentialsProps> = ({ username, password }) => {
    const [showCredentials, setShowCredentials] = useState(false);

    const handleRevealClick = () => {
        setShowCredentials(!showCredentials);
    };

    return (
        <div className="container">
            <div className="d-flex align-items-center">
                <div className="me-3 d-flex align-items-center">
                    <label className="form-label me-2">Username:</label>
                    <input
                        type="text"
                        className="form-control"
                        value={showCredentials ? username : '********'}
                        readOnly
                    />
                </div>
                <div className="me-3 d-flex align-items-center">
                    <label className="form-label me-2">Password:</label>
                    <input
                        type="text"
                        className="form-control"
                        value={showCredentials ? password : '********'}
                        readOnly
                    />
                </div>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleRevealClick}
                >
                    {showCredentials ? 'Hide' : 'Reveal'}
                </button>
            </div>
        </div>
    );
};

export default CredentialsReveal;
